import { format } from 'date-fns';
import { capitalize } from '../textUtils';

const dayTranslation: Record<string, string> = {
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
};

export const getSpanishDateDayName = ({
  date = new Date(),
  isString = false,
}: { date?: Date | string; isString?: boolean } = {}) => {
  const dateToTranslate = isString || typeof date === 'string' ? new Date(date) : date;
  return dayTranslation[format(dateToTranslate, 'EEEE')];
};

export const translateDayNameToSpanish = (dayName: string | unknown) => {
  if (typeof dayName !== 'string') return '';
  return dayTranslation[capitalize(dayName.toLowerCase())] || dayName;
};
